import React from 'react';
import { compose, withState, withProps } from 'recompose';
import Alert from 'components/modals/Alert'

/**
 * BaseComponent will receive props: onToggleSubmitModal
 *
 * onToggleSubmitModal accepts function that will be called
 * when user click submit(call submitModalAction) button in modal
 *
 * more info. action that is sent to onToggleSubmitModal(action)
 * is stored in state of withModalSubmit HOC
 */
export const withModalSubmit = () => compose(
  withState('openSubmitModal', 'toggleSubmitModal', false),
  withState('submitModalAction', 'storeSubmitModalAction', (props) => () => {}),
  withProps(({
    toggleSubmitModal,
    submitModalAction,
    storeSubmitModalAction,
  }) => ({
    submitModalAction, // use this function in submit button
    onToggleSubmitModal: (action) => {
      if (typeof action === 'function') {
        // look at recompose, stateUpdater will start with (state) in this case
        const submitAction = (...params) => {
          // two actions will happens
          // 1. call action
          action(...params);
          // 2. close Modal
          return toggleSubmitModal(false);
        };
        storeSubmitModalAction((state) => submitAction);
      }
      return toggleSubmitModal(true);
    },
    onCloseSubmitModal: () => toggleSubmitModal(false),
  })),
  withProps(
    ({
      openSubmitModal,
      submitModalAction,
      onCloseSubmitModal,
    }) => ({
      renderSubmitModal: () => (
        <Alert
          open={openSubmitModal}
          onSubmit={submitModalAction}
          onCancel={onCloseSubmitModal}
        />
      ),
    }),
  ),
);




// WEBPACK FOOTER //
// ./src/hocs/bases/withModalSubmit.js